import { openModal } from '../helpers/modals.js';

const selectors = {
  imageTrigger: '[data-wall-of-shame-image]',
  modalContent: '[data-wall-of-shame-modal-content]',
  modalImage: '[data-wall-of-shame-modal-image]',
};

export default class DynamicWallOfShame {
  constructor(section) {
    this.el = section.el;
    this.id = section.id;
    this.modalId = `wall-of-shame-modal-${section.id}`;
    this.imageClickHandlers = [];
    this.modalCloseHandler = null;
    this.init();
  }

  init() {
    const imageTriggers = this.el.querySelectorAll(selectors.imageTrigger);
    const modal = document.getElementById(this.modalId);

    if (!imageTriggers.length || !modal) {
      return;
    }

    // Set up image click handlers
    imageTriggers.forEach(trigger => {
      const handler = e => {
        e.preventDefault();
        this.handleImageClick(trigger);
      };
      trigger.addEventListener('click', handler);
      this.imageClickHandlers.push({ trigger, handler });
    });

    // Listen for modal close events to clear the image
    this.modalCloseHandler = () => {
      this.clearModalImage();
    };
    modal.addEventListener('modal:closed', this.modalCloseHandler);
  }

  handleImageClick(trigger) {
    const imageUrl = trigger.getAttribute('data-image-url');
    const imageAlt = trigger.getAttribute('data-image-alt') || '';

    // Find modal image element - reuse the same img element
    const modalImage = this.el.querySelector(selectors.modalImage);
    const modal = document.getElementById(this.modalId);

    if (!modalImage || !imageUrl || !modal) {
      console.warn('Wall of Shame: Modal elements not found');
      return;
    }

    // Clear the old image immediately to prevent flash
    modalImage.src = '';
    modalImage.alt = '';

    // Use requestAnimationFrame to ensure the src is cleared before setting new one
    requestAnimationFrame(() => {
      modalImage.src = imageUrl;
      modalImage.alt = imageAlt;
    });

    // Open the modal immediately
    openModal(this.modalId);
  }

  clearModalImage() {
    const modalImage = this.el.querySelector(selectors.modalImage);
    if (modalImage) {
      modalImage.src = '';
      modalImage.alt = '';
    }
  }

  onSectionUnload() {
    // Clean up event listeners
    this.imageClickHandlers.forEach(({ trigger, handler }) => {
      trigger.removeEventListener('click', handler);
    });
    this.imageClickHandlers = [];

    // Clean up modal close listener
    const modal = document.getElementById(this.modalId);
    if (modal && this.modalCloseHandler) {
      modal.removeEventListener('modal:closed', this.modalCloseHandler);
    }
  }
}
